var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-button",class:_vm.menu_button_class,on:{"click":_vm.onClick}},[_c('span',{staticClass:"menu-line menu-line-1"}),_c('span',{staticClass:"menu-line menu-line-2"}),_c('span',{staticClass:"menu-line menu-line-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }